import {getToken} from '@/libs/util'
import {getUserInfo} from '@/api/user/user'
import config2 from '@/config'

const baseUrl = process.env.NODE_ENV === 'development' ? config2.baseUrl.dev : config2.baseUrl.pro;

export default {
	state: {
		token: getToken(),
		userInfo: {},
		// 长链接对象
		sseScore: null,
	},
	mutations: {},
	getters: {},
	actions: {
		// 获取用户信息
		getUserInfo({state, commit}) {
			return new Promise((resolve, reject) => {
				try {
					getUserInfo().then(res => {
						const data = res.data;
						state.userInfo = data.data;
						resolve(data)
					}).catch(err => {
						reject(err)
					})
				} catch (error) {
					reject(error)
				}
			})
		},
		// 此方法用来获取未读消息条数，接口只返回数值，不返回消息列表
		getdiffPackStatis({state, commit}, that) {
			if (state.sseScore) {
				state.sseScore.close();
			}
			state.sseScore = new EventSource(baseUrl + "/api/v1/comm/getdiffPackStatis?token=" + state.token);
			state.sseScore.onmessage = function (event) {
				if (!event.data) return;
				let data = JSON.parse(event.data);
				if (data.length) {
					for (let i = 0; i < data.length; i++) {
						that.$Notice.warning({
							title: "差异分拣提醒",
							desc: `${data[i].productName}--存在差异分拣，请及时处理`,
							render: h => {
								return h('div', [
									h('p', `${data[i].productName}--存在差异分拣，请及时处理`),
									h('div', {style: {width: '100%', display: 'flex', justifyContent: 'flex-end'}}, [h('Button', {
										props: {
											type: 'primary',
										}, on: {
											click: () => {
												that.$router.push({name: "diffSorting",});
												that.$Notice.destroy()
											}
										}
									}, '前往处理')])

								])
							},
							duration: 0
						})
					}
				}
			};
		},
	}
}



// WEBPACK FOOTER //
// ./src/store/module/user.js